import React from 'react';
import {observer} from 'mobx-react';
import {Card} from 'antd';
import orderDetailStore from '@store/User/UserList/OrderDetailStore';


@observer
class OrderDetailPlanModal extends React.Component {
    constructor() {
        super();
        this.state = {someKey: 'someValue'};
    }

    render() {

        let TypeStyle = {
            color: 'black',
            fontWeight: '900'
        };

        let RedTypeStyle = {
            color: 'red',
            fontWeight: '900'
        };

        let SingleRowStyle = {
            width: "100%",
            padding: '10px'
        };

        let HalfRowStyle = {
            width: "50%",
            padding: '10px',
            textAlign: "center"
        };

        let ItemRowStyle = {
            width: "33%",
            padding: '10px',
            textAlign: "center"
        };


        return (
            <Card title='方案详情'>
                <Card.Grid style={HalfRowStyle}><span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.typeName}</span></Card.Grid>
                <Card.Grid style={HalfRowStyle}>第<span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.term_data.term_no}</span>期</Card.Grid>
                <Card.Grid style={ItemRowStyle}>编号:<span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.plan_data.number_no}</span></Card.Grid>
                <Card.Grid style={ItemRowStyle}>购买类型:<span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.plan_type}</span></Card.Grid>
                <Card.Grid style={ItemRowStyle}>倍数:<span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.multiple}</span></Card.Grid>
                <Card.Grid style={ItemRowStyle}>出票状态:<span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.status_name}</span></Card.Grid>
                <Card.Grid style={ItemRowStyle}>开奖状态:<span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.order_result_name}</span></Card.Grid>
                <Card.Grid style={ItemRowStyle}>注单付款情况:<span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.payStatusName}</span></Card.Grid>
                <Card.Grid style={ItemRowStyle}>方案金额:<span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.plan_data.money}</span></Card.Grid>
                <Card.Grid style={ItemRowStyle}>出票金额:<span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.out_amount}</span></Card.Grid>
                <Card.Grid style={ItemRowStyle}>中奖金额:<span
                    style={orderDetailStore.orderDetailData.win_money > 0 ? RedTypeStyle : TypeStyle}>{orderDetailStore.orderDetailData.win_money}</span></Card.Grid>
                <Card.Grid style={ItemRowStyle}>出票接口:<span
                    style={TypeStyle}>{orderDetailStore.orderDetailData.ticket_third_name}</span></Card.Grid>
            </Card>
        );
    }

    componentDidMount() {
        this.setState({someKey: 'otherValue'});
    }
}

export default OrderDetailPlanModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/Order/OrderDetailPlanModal.jsx